import classNames from "classnames";
import { GatsbyImage, IGatsbyImageData } from "gatsby-plugin-image";
import React from "react";
import { HalfWidthClassName, MainShortWidthClassName } from "../styles";

export const ImageHero: React.FC<{
  image: IGatsbyImageData;
  alt?: string | null;
  title?: string | null;
  heading?: string | null;
}> = ({ image, alt, title, heading }) => {
  return (
    <section data-component="Image Hero" className="relative h-screen">
      <GatsbyImage
        className="left-0 top-0 h-full w-full"
        style={{ position: "absolute" }}
        image={image}
        alt={alt ?? "Hero image"}
        objectFit="cover"
      />
      <div className="page-grid relative left-0 top-0 h-full w-full auto-rows-max pt-20px lg:pt-40px">
        {title && !heading && (
          <h1
            className={classNames(
              "h1 col-span-4 col-start-2 mt-445px text-cotton",
            )}
          >
            {title}
          </h1>
        )}
        {title && heading && (
          <>
            <h1
              className={classNames(
                "h1 pt-40px text-hyacinth md:pt-100px lg:pt-100px",
                HalfWidthClassName,
              )}
            >
              {title}
            </h1>
            <h2
              className={classNames(
                "h2 pt-20px text-cotton",
                MainShortWidthClassName,
              )}
            >
              {heading}
            </h2>
          </>
        )}
      </div>
    </section>
  );
};
